import Invitation from './Invitation';
import {makeAutoObservable} from 'mobx';
import dayjs from 'dayjs';

export default class Plan {
  id: string;
  start: string;
  start_human: string;
  title: string;
  location: string;
  description: string;
  invitations: Invitation[];
  init_summary: string;

  constructor(id: string, name: string, location: string, description: string, datetime: string, invitations: Invitation[]) {
    this.id = id;
    this.start = datetime ? datetime : new Date().toISOString();
    this.start_human = dayjs(this.start).format('MMMM D, YYYY h:mm A');
    this.title = name;
    this.location = location;
    this.description = description;
    this.invitations = invitations;
    this.init_summary = '';
    makeAutoObservable(this);
  }
}
